module.exports = __webpack_public_path__ + "fonts/Helios-bold.79b8c72f.ttf";